import api from "@/lib/api";

const SW_PATH = "/service-worker.js";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function isPushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export async function ensureServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  const existing = await navigator.serviceWorker.getRegistration(SW_PATH);
  if (existing) return existing;
  return navigator.serviceWorker.register(SW_PATH, { scope: "/" });
}

export async function getCurrentSubscription() {
  const reg = await ensureServiceWorker();
  if (!reg) return null;
  return reg.pushManager.getSubscription();
}

export async function enablePush() {
  if (!isPushSupported()) throw new Error("Notifiche push non supportate su questo browser");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permesso notifiche negato");
  const reg = await ensureServiceWorker();
  if (!reg) throw new Error("Service Worker non registrato");
  const { data } = await api.get("/push/public-key");
  const key = urlBase64ToUint8Array(data.public_key);
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: key });
  }
  await api.post("/push/subscribe", sub.toJSON());
  return sub;
}

export async function disablePush() {
  const sub = await getCurrentSubscription();
  if (!sub) return { ok: true };
  try {
    await api.post("/push/unsubscribe", { endpoint: sub.endpoint });
  } catch (_) {}
  await sub.unsubscribe();
  return { ok: true };
}

export async function pushStatus() {
  try {
    const [{ data }, localSub] = await Promise.all([
      api.get("/push/status"),
      getCurrentSubscription(),
    ]);
    return { server: !!data.active, local: !!localSub };
  } catch (_) {
    return { server: false, local: false };
  }
}
